import React, { useState, useEffect, useRef } from 'react';
import { useSlider } from '../hooks/useSlider';
import DescriptionIcon from '@mui/icons-material/Description';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const Products = () => {
  const products = [
    {
      title: 'Весы настольные электронные',
      description: 'Точные настольные весы для кондитерских цехов, пекарен и кафе. Идеальны для взвешивания сырья и готовой продукции.',
      image: 'https://www.refro.ru/upload/iblock/c6c/rzbknjb3qh4aa4xtwduaf3w50gbkjv5q.jpg',
    },
    {
      title: 'Весы платформенные электронные',
      description: 'Надежные платформенные весы для склада и зоны приема сырья. Большая платформа для взвешивания крупногабаритных грузов.',
      image: 'https://www.refro.ru/upload/iblock/d38/5di5tex9zv6oxf9znsfzsdd9gctad8ge.jpg',
    },
    {
      title: 'Весы складские',
      description: 'Промышленные весы для складского учета ингредиентов. Выдерживают высокие нагрузки и интенсивную эксплуатацию.',
      image: 'https://www.refro.ru/upload/resize_cache/iblock/d42/3000_3000_140cd750bba9870f18aada2478b24840a/92rg9p7y80ayin243950ywda4jc75t4q.jpg',
    },
    {
      title: 'Весы торговые электронные',
      description: 'Торговые весы с печатью этикеток для кафе и ресторанов. Подходит для взвешивания готовой продукции в торговом зале.',
      image: 'https://www.refro.ru/upload/iblock/131/a1ajq88noxfztfs7ysnxjibcjk7ii0pj.jpg',
    },
    {
      title: 'Кофейные весы',
      description: 'Прецизионные весы для кофейных зон и пекарен. Высокая точность до 0.1г для приготовления напитков и выпечки.',
      image: 'https://www.refro.ru/upload/iblock/b15/dnfyy110v23b1v33v49a3qvn06265j8f.jpg',
    },
    {
      title: 'Программы для пекарен и кондитерских',
      description: 'Управление рецептами, технологическими картами и производственным планом.',
      image: 'https://avatars.mds.yandex.net/i?id=bf3cb9dc1d391d3f62f48f345ce21eb3_l-4724533-images-thumbs&n=13',
    },
    {
      title: 'Модули автоматизации приготовления',
      description: 'Пошаговые инструкции с указанием точного количества ингредиентов для каждого изделия (торты, пирожные и др.).',
      image: 'https://avatars.mds.yandex.net/i?id=a96d0b5c887bd39887a83ff4898093622d49f5b1-4900601-images-thumbs&n=13',
    },
    {
      title: 'Система автоматизации взвешивания',
      description: 'Интегрированная система для точного взвешивания и дозирования сырья.',
      image: 'https://i.pinimg.com/originals/42/d3/5e/42d35e600fac24e2551a7c1d7298899f.png',
    },
    {
      title: 'Программное обеспечение',
      description: 'Программное обеспечение для учета взвешиваний грузов.',
      image: 'https://производитель.рф/files/pubtext/СТАТ%20МЕТОДЫ.jpg',
      downloadLink: '/WeighingJournal.7z',
      documentationLink: '#',
    },
  ];

  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);
  const slider = useSlider(products.length);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  const {
    currentIndex,
    translateX,
    duplicatedProductIndices,
    pauseAutoPlay,
    resumeAutoPlay,
    nextSlide,
    prevSlide,
    handleMouseDown,
    handleMouseUp,
    handleTouchStart,
    handleTouchEnd,
  } = slider;

  return (
    <section 
      id="products" 
      className="products fade-in-section" 
      ref={ref}
      style={{ 
        opacity: isVisible ? 1 : 0, 
        transform: isVisible ? 'translateY(0)' : 'translateY(50px)' 
      }}
    >
      <div className="products-full-width">
        <div className="container">
          <h2>Наши продукты</h2>
          
          <div className="slider-controls">
            <button
              className="slider-btn prev" 
              onClick={prevSlide}
            >
              <ChevronLeftIcon />
            </button>

            <button 
              className="slider-btn next" 
              onClick={nextSlide}
            >
              <ChevronRightIcon />
            </button>
          </div>

          <div className="slider-track-wrapper">
            <div 
              className="slider-track"
              style={{ transform: `translateX(${translateX}px)` }}
              onMouseDown={handleMouseDown}
              onMouseUp={handleMouseUp}
              onMouseLeave={handleMouseUp}
              onTouchStart={handleTouchStart}
              onTouchEnd={handleTouchEnd}
              onMouseEnter={pauseAutoPlay}
              onMouseLeave={resumeAutoPlay}
            >
              {duplicatedProductIndices.map((productIndex, index) => (
                <div key={index} className="product-item">
                  <img src={products[productIndex].image} alt={products[productIndex].title} />
                  <h3>{products[productIndex].title}</h3>
                  <p>{products[productIndex].description}</p>
                  {products[productIndex].downloadLink && (
                    <div className="product-actions">
                      <a href={products[productIndex].downloadLink} className="btn" download>
                        Скачать
                      </a>
                      {products[productIndex].documentationLink && products[productIndex].documentationLink !== '#' && (
                        <a
                          href={products[productIndex].documentationLink}
                          className="btn"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <DescriptionIcon fontSize="small" />
                          Документация
                        </a>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="slider-dots">
            {Array.from({ length: products.length }).map((_, index) => (
              <button
                key={index}
                className={`dot ${currentIndex === index + 1 ? 'active' : ''}`}
                onClick={() => {}}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;
